import type { IdentityService } from '../network/IdentityService';

/** Explains an unverified saved credential without exposing cached identity. */
export class SessionRecovery {
  public constructor(root: HTMLElement, identity: IdentityService) {
    const panel = root.querySelector<HTMLElement>('[data-session-recovery]');
    const status = root.querySelector<HTMLElement>('[data-session-recovery-status]');
    const retry = root.querySelector<HTMLButtonElement>('[data-session-recovery-retry]');
    const landing = root.querySelector<HTMLElement>('[data-landing]');
    if (!panel || !status || !retry || !landing) throw new Error('Session recovery controls are missing');

    retry.addEventListener('click', () => { void identity.retryRestoration(); });
    identity.subscribe(() => {
      const state = identity.restoration();
      landing.classList.toggle('is-restoring-session', state !== 'none');
      panel.hidden = state === 'none';
      retry.disabled = state !== 'unavailable';
      retry.textContent = state === 'checking' ? 'CHECKING SESSION…' : 'RETRY SAVED SESSION';
      status.textContent = state === 'checking'
        ? 'Checking your saved session with the Station…'
        : 'Your saved session could not be checked. Retry when the connection returns, or log in below.';
    });
  }
}
